exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".FiscalSalesVisualizer{color:red}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./src/app/pages/fiscal-sales-visualizer/fiscal-sales-visualizer.scss
// module id = 1350
// module chunks = 0